import {
  GET_SALES_ORDER_BILL_OF_MATERIALS,
  GET_SALES_ORDER_BILL_OF_MATERIALS_SUCCESS,
  GET_SALES_ORDER_BILL_OF_MATERIALS_FAILURE,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_SUCCESS,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_FAILURE,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_SUCCESS,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_FAILURE,
  SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT,
  SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  GET_BOM_COMPONENT_LIST,
  GET_BOM_COMPONENT_LIST_SUCCESS,
  GET_BOM_COMPONENT_LIST_FAILURE,
  GET_BOM_COMPONENT_DATA,
  GET_BOM_COMPONENT_DATA_SUCCESS,
  GET_BOM_COMPONENT_DATA_FAILURE,
  SEARCH_BOM_COMPONENT,
  SEARCH_BOM_COMPONENT_SUCCESS,
  SEARCH_BOM_COMPONENT_FAILURE,
  CREATE_BOM_COMPONENT,
  CREATE_BOM_COMPONENT_SUCCESS,
  CREATE_BOM_COMPONENT_FAILURE,
  UPDATE_BOM_COMPONENT,
  UPDATE_BOM_COMPONENT_SUCCESS,
  UPDATE_BOM_COMPONENT_FAILURE,
  DELETE_BOM_COMPONENT,
  DELETE_BOM_COMPONENT_SUCCESS,
  DELETE_BOM_COMPONENT_FAILURE,
  GET_BOM_LIST,
  GET_BOM_LIST_SUCCESS,
  GET_BOM_LIST_FAILURE,
  GET_BOM_DATA,
  GET_BOM_DATA_SUCCESS,
  GET_BOM_DATA_FAILURE,
  SEARCH_BOM,
  SEARCH_BOM_SUCCESS,
  SEARCH_BOM_FAILURE,
  CREATE_BOM,
  CREATE_BOM_SUCCESS,
  CREATE_BOM_FAILURE,
  UPDATE_BOM,
  UPDATE_BOM_SUCCESS,
  UPDATE_BOM_FAILURE,
  DELETE_BOM,
  DELETE_BOM_SUCCESS,
  DELETE_BOM_FAILURE,
  CREATE_BOM_VERSION,
  CREATE_BOM_VERSION_SUCCESS,
  CREATE_BOM_VERSION_FAILURE,
  CLONE_BOM,
  CLONE_BOM_SUCCESS,
  CLONE_BOM_FAILURE,
  SEARCH_PRODUCT_TO_BOM,
  SEARCH_PRODUCT_TO_BOM_SUCCESS,
  SEARCH_PRODUCT_TO_BOM_FAILURE,
  SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE,
  SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_SUCCESS,
  SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_FAILURE,
} from "./actionType";

//GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST
export const getBomComponentSupplierProductList = () => ({
  type: GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST,
});
export const getBomComponentSupplierProductListSuccess = (data) => ({
  type: GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_SUCCESS,
  payload: data,
});
export const getBomComponentSupplierProductListFailure = (error) => ({
  type: GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_FAILURE,
  payload: error,
});
//GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA
export const getBomComponentSupplierProductData = (id) => ({
  type: GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA,
  payload: id,
});
export const getBomComponentSupplierProductDataSuccess = (data) => ({
  type: GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_SUCCESS,
  payload: data,
});
export const getBomComponentSupplierProductDataFailure = (error) => ({
  type: GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_FAILURE,
  payload: error,
});
//SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT
export const searchBomComponentSupplierProduct = (query) => ({
  type: SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT,
  payload: query,
});
export const searchBomComponentSupplierProductSuccess = (data) => ({
  type: SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  payload: data,
});
export const searchBomComponentSupplierProductFailure = (error) => ({
  type: SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  payload: error,
});
//CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT
export const createBomComponentSupplierProduct = (data) => ({
  type: CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  payload: data,
});
export const createBomComponentSupplierProductSuccess = (data) => ({
  type: CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  payload: data,
});
export const createBomComponentSupplierProductFailure = (error) => ({
  type: CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  payload: error,
});
//UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT
export const updateBomComponentSupplierProduct = (data) => ({
  type: UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  payload: data,
});
export const updateBomComponentSupplierProductSuccess = (data) => ({
  type: UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  payload: data,
});
export const updateBomComponentSupplierProductFailure = (error) => ({
  type: UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  payload: error,
});
//DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT
export const deleteBomComponentSupplierProduct = (id) => ({
  type: DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  payload: id,
});
export const deleteBomComponentSupplierProductSuccess = (id) => ({
  type: DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  payload: id,
});
export const deleteBomComponentSupplierProductFailure = (error) => ({
  type: DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  payload: error,
});
//GET_BOM_COMPONENT_LIST
export const getBomComponentList = () => ({
  type: GET_BOM_COMPONENT_LIST,
});
export const getBomComponentListSuccess = (data) => ({
  type: GET_BOM_COMPONENT_LIST_SUCCESS,
  payload: data,
});
export const getBomComponentListFailure = (error) => ({
  type: GET_BOM_COMPONENT_LIST_FAILURE,
  payload: error,
});
//GET_BOM_COMPONENT_DATA
export const getBomComponentData = (id) => ({
  type: GET_BOM_COMPONENT_DATA,
  payload: id,
});
export const getBomComponentDataSuccess = (data) => ({
  type: GET_BOM_COMPONENT_DATA_SUCCESS,
  payload: data,
});
export const getBomComponentDataFailure = (error) => ({
  type: GET_BOM_COMPONENT_DATA_FAILURE,
  payload: error,
});
//SEARCH_BOM_COMPONENT
export const searchBomComponent = (query) => ({
  type: SEARCH_BOM_COMPONENT,
  payload: query,
});
export const searchBomComponentSuccess = (data) => ({
  type: SEARCH_BOM_COMPONENT_SUCCESS,
  payload: data,
});
export const searchBomComponentFailure = (error) => ({
  type: SEARCH_BOM_COMPONENT_FAILURE,
  payload: error,
});
//CREATE_BOM_COMPONENT
export const createBomComponent = (data) => ({
  type: CREATE_BOM_COMPONENT,
  payload: data,
});
export const createBomComponentSuccess = (data) => ({
  type: CREATE_BOM_COMPONENT_SUCCESS,
  payload: data,
});
export const createBomComponentFailure = (error) => ({
  type: CREATE_BOM_COMPONENT_FAILURE,
  payload: error,
});
//UPDATE_BOM_COMPONENT
export const updateBomComponent = (data) => ({
  type: UPDATE_BOM_COMPONENT,
  payload: data,
});
export const updateBomComponentSuccess = (data) => ({
  type: UPDATE_BOM_COMPONENT_SUCCESS,
  payload: data,
});
export const updateBomComponentFailure = (error) => ({
  type: UPDATE_BOM_COMPONENT_FAILURE,
  payload: error,
});
//DELETE_BOM_COMPONENT
export const deleteBomComponent = (id) => ({
  type: DELETE_BOM_COMPONENT,
  payload: id,
});
export const deleteBomComponentSuccess = (id) => ({
  type: DELETE_BOM_COMPONENT_SUCCESS,
  payload: id,
});
export const deleteBomComponentFailure = (error) => ({
  type: DELETE_BOM_COMPONENT_FAILURE,
  payload: error,
});
//GET_BOM_LIST
export const getBomList = () => ({
  type: GET_BOM_LIST,
});
export const getBomListSuccess = (data) => ({
  type: GET_BOM_LIST_SUCCESS,
  payload: data,
});
export const getBomListFailure = (error) => ({
  type: GET_BOM_LIST_FAILURE,
  payload: error,
});
//GET_BOM_DATA
//GET_SALES_ORDER_BILL_OF_MATERIALS
export const getSalesOrderBillOfMaterials = (id) => ({
  type: GET_SALES_ORDER_BILL_OF_MATERIALS,
  payload: id,
});
export const getSalesOrderBillOfMaterialsSuccess = (data) => ({
  type: GET_SALES_ORDER_BILL_OF_MATERIALS_SUCCESS,
  payload: data,
});
export const getSalesOrderBillOfMaterialsFailure = (error) => ({
  type: GET_SALES_ORDER_BILL_OF_MATERIALS_FAILURE,
  payload: error,
});

export const getBomData = (id) => ({
  type: GET_BOM_DATA,
  payload: id,
});
export const getBomDataSuccess = (data) => ({
  type: GET_BOM_DATA_SUCCESS,
  payload: data,
});
export const getBomDataFailure = (error) => ({
  type: GET_BOM_DATA_FAILURE,
  payload: error,
});
//SEARCH_BOM
export const searchBom = (query) => ({
  type: SEARCH_BOM,
  payload: query,
});
export const searchBomSuccess = (data) => ({
  type: SEARCH_BOM_SUCCESS,
  payload: data,
});
export const searchBomFailure = (error) => ({
  type: SEARCH_BOM_FAILURE,
  payload: error,
});
//CREATE_BOM
export const createBom = (data) => ({
  type: CREATE_BOM,
  payload: data,
});
export const createBomSuccess = (data) => ({
  type: CREATE_BOM_SUCCESS,
  payload: data,
});
export const createBomFailure = (error) => ({
  type: CREATE_BOM_FAILURE,
  payload: error,
});
//UPDATE_BOM
export const updateBom = (data) => ({
  type: UPDATE_BOM,
  payload: data,
});
export const updateBomSuccess = (data) => ({
  type: UPDATE_BOM_SUCCESS,
  payload: data,
});
export const updateBomFailure = (error) => ({
  type: UPDATE_BOM_FAILURE,
  payload: error,
});
//DELETE_BOM
export const deleteBom = (id) => ({
  type: DELETE_BOM,
  payload: id,
});
export const deleteBomSuccess = (id) => ({
  type: DELETE_BOM_SUCCESS,
  payload: id,
});
export const deleteBomFailure = (error) => ({
  type: DELETE_BOM_FAILURE,
  payload: error,
});
//CREATE_BOM_VERSION
export const createBomVersion = (data) => ({
  type: CREATE_BOM_VERSION,
  payload: data,
});
export const createBomVersionSuccess = (data) => ({
  type: CREATE_BOM_VERSION_SUCCESS,
  payload: data,
});
export const createBomVersionFailure = (error) => ({
  type: CREATE_BOM_VERSION_FAILURE,
  payload: error,
});

//CLONE_BOM
export const cloneBom = (data) => ({
  type: CLONE_BOM,
  payload: data,
});
export const cloneBomSuccess = (data) => ({
  type: CLONE_BOM_SUCCESS,
  payload: data,
});
export const cloneBomFailure = (error) => ({
  type: CLONE_BOM_FAILURE,
  payload: error,
});

//SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE
export const searchProductBomToProductRule = (query) => ({
  type: SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE,
  payload: query,
});
export const searchProductBomToProductRuleSuccess = (data) => ({
  type: SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_SUCCESS,
  payload: data,
});
export const searchProductBomToProductRuleFailure = (error) => ({
  type: SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_FAILURE,
  payload: error,
});

//SEARCH_PRODUCT_TO_BOM
export const searchProductToBom = (query) => ({
  type: SEARCH_PRODUCT_TO_BOM,
  payload: query,
});
export const searchProductToBomSuccess = (data) => ({
  type: SEARCH_PRODUCT_TO_BOM_SUCCESS,
  payload: data,
});
export const searchProductToBomFailure = (error) => ({
  type: SEARCH_PRODUCT_TO_BOM_FAILURE,
  payload: error,
});
